export default __webpack_public_path__ + "static/media/tented.5fbd1154.png";